import React, { useContext } from "react";

import {
    ImageChooserBlock as ImageChooserBlockValue,
    RecipePageBody as RecipePageBodyValue,
} from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { ReactivatedContext as Context } from "../../context";
import { CenteredHero, CenteredHeroBlock } from "../CenteredHero";
import { MediaChooserBlock } from "../MediaChooserBlock";
import { toolboxComponents } from "../PageSkeleton/Toolbox";
import { RecipeAttributionBlock } from "../RecipeAttributionBlock";
import { RecipeHeaderBlock } from "../RecipeHeaderBlock";
import { RecipeInstructionsBlock } from "../RecipeInstructionsBlock";

import styles from "./index.module.scss";

const recipeStreamComponents = {
    ...toolboxComponents,
    header: RecipeHeaderBlock,
    instructions: RecipeInstructionsBlock,
    attribution: RecipeAttributionBlock,
};

export const RecipePageBody = (props: {
    title: string;
    hero: ImageChooserBlockValue | null;
    body: RecipePageBodyValue;
}) => {
    const isV2026 = useContext(Context).DESIGN_VERSION === "v2026";

    if (isV2026) {
        return (
            <article className={styles.recipe}>
                {props.hero ? (
                    <CenteredHero
                        content={
                            <h1 className={styles.heroTitle}>{props.title}</h1>
                        }
                        media={
                            <MediaChooserBlock
                                value={[
                                    {
                                        type: "image",
                                        value: props.hero,
                                        id: "recipe-page-body-id",
                                    },
                                ]}
                            />
                        }
                        height="standard"
                    />
                ) : (
                    <h1 className={styles.fallbackTitle}>{props.title}</h1>
                )}
                <section className={styles.inner}>
                    <StreamField
                        components={recipeStreamComponents}
                        value={props.body}
                        tagName={React.Fragment}
                    />
                </section>
            </article>
        );
    }

    return (
        <article className={styles.recipe}>
            {props.hero && (
                <CenteredHeroBlock
                    value={{
                        media: [
                            {
                                type: "image",
                                value: props.hero,
                                id: "recipe-page-body-id",
                            },
                        ],
                        content: null,
                        height: "standard",
                    }}
                />
            )}
            <section className={styles.inner}>
                <h1 className={styles.title}>{props.title}</h1>
                <StreamField
                    components={recipeStreamComponents}
                    value={props.body}
                    tagName={React.Fragment}
                />
            </section>
        </article>
    );
};
